export default __webpack_public_path__ + "static/media/HomeAPp.71bd6627.jpg";